// Traductions du mode Lite : page Discipline (routine du jour, objectifs), tiroirs, card du dashboard.
export const fr = {
  title: "Discipline",
  routine: {
    title: "Routine du jour",
    progress: (done: number, total: number) => `${done} sur ${total} items`,
    streak: (n: number) => `${n} jour${n > 1 ? "s" : ""} d'affilée`,
    allDone: "Routine complète. Bonne session.",
    add: "Nouvelle routine",
    edit: "Modifier la routine",
    emptyTitle: "Pas encore de routine",
    emptyText: "Une checklist à cocher chaque jour avant de trader : plan, niveaux, état d'esprit. Ce que tu fais tous les jours finit par se voir dans tes résultats.",
    emptyCta: "Créer ma routine",
    frequency: { weekly: "Hebdo", monthly: "Mensuelle", custom: "Libre" },
  },
  goals: {
    title: "Objectifs",
    inProgress: (n: number) => `${n} en cours`,
    add: "Nouvel objectif",
    edit: "Modifier l'objectif",
    emptyTitle: "Pas encore d'objectif",
    emptyText: "Un résultat à atteindre sur la journée, la semaine ou le mois. Edgely suit la progression avec tes trades.",
    emptyCta: "Créer mon objectif",
    type: { pnl: "PnL", win_rate: "Win rate", trades_count: "Trades", custom: "Libre" },
    period: { daily: "Jour", weekly: "Semaine", monthly: "Mois" },
    remaining: (days: number) => (days === 0 ? "aujourd'hui" : `${days} jour${days > 1 ? "s" : ""} restant${days > 1 ? "s" : ""}`),
    achieved: "Atteint",
    markDone: "Marquer comme atteint",
    trades: (n: number) => `${n} trade${n > 1 ? "s" : ""}`,
    recentPeriods: "Dernières périodes",
    completed: (n: number) => `${n} objectif${n > 1 ? "s" : ""} atteint${n > 1 ? "s" : ""}`,
    showCompleted: "Voir",
    hideCompleted: "Masquer",
  },
  form: {
    routineName: "Nom de la routine",
    routineNamePlaceholder: "Ex : Avant la session",
    items: "Items à cocher",
    itemPlaceholder: "Ex : Relire mon plan",
    addItem: "Ajouter un item",
    removeItem: "Retirer",
    itemRequired: "Ajoute au moins un item.",
    goalTitle: "Titre",
    goalTitlePlaceholder: "Ex : 500 $ par jour",
    goalType: "Type",
    goalTarget: "Cible",
    goalPeriod: "Période",
    customHint: "Un objectif libre se coche à la main quand tu l'estimes atteint.",
    save: "Enregistrer",
    delete: "Supprimer",
    confirmDelete: "Confirmer la suppression",
    error: "Impossible d'enregistrer. Réessaie.",
  },
  dashboard: {
    title: "Discipline du jour",
    routine: "Routine",
    link: "Voir la discipline",
    emptyTitle: "Crée ta routine du jour",
    emptyText: "Une checklist avant de trader et un objectif à suivre : c'est là que la régularité se construit.",
    emptyCta: "Commencer",
  },
};

export const en: typeof fr = {
  title: "Discipline",
  routine: {
    title: "Today's routine",
    progress: (done: number, total: number) => `${done} of ${total} items`,
    streak: (n: number) => `${n} day${n > 1 ? "s" : ""} in a row`,
    allDone: "Routine complete. Have a good session.",
    add: "New routine",
    edit: "Edit routine",
    emptyTitle: "No routine yet",
    emptyText: "A checklist to tick every day before trading: plan, levels, mindset. What you do every day ends up showing in your results.",
    emptyCta: "Create my routine",
    frequency: { weekly: "Weekly", monthly: "Monthly", custom: "Custom" },
  },
  goals: {
    title: "Goals",
    inProgress: (n: number) => `${n} in progress`,
    add: "New goal",
    edit: "Edit goal",
    emptyTitle: "No goal yet",
    emptyText: "A result to reach over the day, the week or the month. Edgely tracks progress from your trades.",
    emptyCta: "Create my goal",
    type: { pnl: "PnL", win_rate: "Win rate", trades_count: "Trades", custom: "Custom" },
    period: { daily: "Day", weekly: "Week", monthly: "Month" },
    remaining: (days: number) => (days === 0 ? "today" : `${days} day${days > 1 ? "s" : ""} left`),
    achieved: "Achieved",
    markDone: "Mark as achieved",
    trades: (n: number) => `${n} trade${n > 1 ? "s" : ""}`,
    recentPeriods: "Recent periods",
    completed: (n: number) => `${n} goal${n > 1 ? "s" : ""} achieved`,
    showCompleted: "Show",
    hideCompleted: "Hide",
  },
  form: {
    routineName: "Routine name",
    routineNamePlaceholder: "e.g. Before the session",
    items: "Items to tick",
    itemPlaceholder: "e.g. Re-read my plan",
    addItem: "Add an item",
    removeItem: "Remove",
    itemRequired: "Add at least one item.",
    goalTitle: "Title",
    goalTitlePlaceholder: "e.g. $500 per day",
    goalType: "Type",
    goalTarget: "Target",
    goalPeriod: "Period",
    customHint: "A custom goal is ticked by hand when you consider it achieved.",
    save: "Save",
    delete: "Delete",
    confirmDelete: "Confirm deletion",
    error: "Could not save. Please try again.",
  },
  dashboard: {
    title: "Today's discipline",
    routine: "Routine",
    link: "See discipline",
    emptyTitle: "Create your daily routine",
    emptyText: "A checklist before trading and a goal to follow: that's where consistency is built.",
    emptyCta: "Start",
  },
};
